export enum RoleType {
  Senior_Manager = 'SeniorManager',
  Supervisor = 'Supervisor',
  Manager = 'Manager',
  Restaurant_Manager = 'Restaurant Manager',
  Staff = 'Staff',
  Admin = 'Admin',
  Super_Admin = 'SuperAdmin'
}
